import styled from 'styled-components';

import { BigSubtitle } from '@genially/design-system';

export const Wrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: size.units(3),
  height: '100%',
}));

export const StyledBigSubtitle = styled(BigSubtitle)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
}));
